import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Action } from '@ngrx/store';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { mergeMap, map, catchError, } from 'rxjs/operators';

import { companyLanguagesActions } from '../actions';
import { CompanyLanguagesHttpService } from '../services';

@Injectable()
export class CompanyLanguagesEffects {

  /* =========================
     Load All Languages
     GET /company-languages
  ========================= */

  loadAllLanguages$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<companyLanguagesActions.LoadAll>(
        companyLanguagesActions.ActionTypes.LOAD_ALL
      ),
      mergeMap((action: companyLanguagesActions.LoadAll) =>
        this.companyLanguagesHttpService.getAllLanguages(action.companyId).pipe(
          map(response =>
            new companyLanguagesActions.LoadAllSuccess(response)
          ),
          catchError(error =>
            of(new companyLanguagesActions.LoadAllFail(error))
          )
        )
      )
    )
  );

  /* =========================
     Load Selected Languages
     GET /selected-company-languages
  ========================= */

  loadSelectedLanguages$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<companyLanguagesActions.LoadSelected>(
        companyLanguagesActions.ActionTypes.LOAD_SELECTED
      ),
      mergeMap((action: companyLanguagesActions.LoadSelected) =>
        this.companyLanguagesHttpService.getSelectedLanguages(action.companyId).pipe(
          map(response =>
            new companyLanguagesActions.LoadSelectedSuccess(response)
          ),
          catchError(error =>
            of(new companyLanguagesActions.LoadSelectedFail(error))
          )
        )
      )
    )
  );

  /* =========================
     Add Selected Languages
     POST
  ========================= */

  addLanguages$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<companyLanguagesActions.Add>(
        companyLanguagesActions.ActionTypes.ADD
      ),
      mergeMap((action: companyLanguagesActions.Add) =>
        this.companyLanguagesHttpService.addLanguages(
          action.companyId,
          action.payload
        ).pipe(
          map(response =>
            new companyLanguagesActions.AddSuccess()
          ),
          catchError(error =>
            of(new companyLanguagesActions.AddFail(error))
          )
        )
      )
    )
  );

  /* =========================
     Update Selected Languages
     PUT
  ========================= */

  updateLanguages$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<companyLanguagesActions.Update>(
        companyLanguagesActions.ActionTypes.UPDATE
      ),
      mergeMap((action: companyLanguagesActions.Update) =>
        this.companyLanguagesHttpService.updateLanguages(
          action.companyId,
          action.payload
        ).pipe(
          map(response =>
            new companyLanguagesActions.UpdateSuccess()
          ),
          catchError(error =>
            of(new companyLanguagesActions.UpdateFail(error))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private companyLanguagesHttpService: CompanyLanguagesHttpService
  ) {}
}
